const middleware = {}

middleware['load-ratings'] = require('../middleware/load-ratings.ts')
middleware['load-ratings'] = middleware['load-ratings'].default || middleware['load-ratings']

middleware['redirects'] = require('../middleware/redirects.ts')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

middleware['redirectToLowerCase'] = require('../middleware/redirectToLowerCase.ts')
middleware['redirectToLowerCase'] = middleware['redirectToLowerCase'].default || middleware['redirectToLowerCase']

export default middleware
